import { Footer } from "../../../components/footer/footer";
import { Header } from "../../../components/header/header";
import styles from "./header-footer-layout.module.scss";

type Props = {
  children: React.ReactNode;
  hideHeader?: boolean;
  hideFooter?: boolean;
};

export function HeaderFooterLayout({ children, hideHeader = false, hideFooter = false }: Props) {
  return (
    <div className={styles.layoutWrapper}>
      {!hideHeader && <Header />}
      {children}
      {!hideFooter && <Footer />}
    </div>
  );
}
